"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MainMenu_1 = __importDefault(require("./MainMenu"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var Modal = /** @class */ (function () {
    function Modal() {
        var _a, _b;
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && Modal.isOpen)
                Modal.closeModal();
        });
        Modal.content = document.querySelectorAll("[".concat(constants_1.DATA_MODAL, "]"));
        Modal.open = document.querySelectorAll("[".concat(constants_1.DATA_MODAL_OPEN, "]"));
        Modal.close = document.querySelectorAll("[".concat(constants_1.DATA_MODAL_CLOSE, "]"));
        Modal.overlay = document.querySelectorAll("[".concat(constants_1.DATA_MODAL_OVERLAY, "]"));
        (_a = Modal.open) === null || _a === void 0 ? void 0 : _a.forEach(function (open) {
            open === null || open === void 0 ? void 0 : open.addEventListener('click', function () {
                Modal.openModal(open);
            });
        });
        (_b = Modal.close) === null || _b === void 0 ? void 0 : _b.forEach(function (close) {
            close === null || close === void 0 ? void 0 : close.addEventListener('click', function () {
                Modal.closeModal();
            });
        });
    }
    Modal.openModal = function (element) {
        var _a, _b;
        this.isOpen = true;
        var attr = element === null || element === void 0 ? void 0 : element.dataset.modalOpen;
        var target = document.querySelector("[".concat(constants_1.DATA_MODAL, "='").concat(attr, "']"));
        MainMenu_1.default.closeMenu();
        (_a = this.content) === null || _a === void 0 ? void 0 : _a.forEach(function (content) { return content === null || content === void 0 ? void 0 : content.classList.remove(constantsClasses_1.CLASS_ACTIVE); });
        target === null || target === void 0 ? void 0 : target.classList.add(constantsClasses_1.CLASS_ACTIVE);
        (_b = this.overlay) === null || _b === void 0 ? void 0 : _b.forEach(function (overlay) { return overlay === null || overlay === void 0 ? void 0 : overlay.classList.add(constantsClasses_1.CLASS_ACTIVE); });
    };
    Modal.closeModal = function () {
        var _a, _b;
        this.isOpen = false;
        (_a = this.content) === null || _a === void 0 ? void 0 : _a.forEach(function (content) { return content === null || content === void 0 ? void 0 : content.classList.remove(constantsClasses_1.CLASS_ACTIVE); });
        (_b = this.overlay) === null || _b === void 0 ? void 0 : _b.forEach(function (overlay) { return overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove(constantsClasses_1.CLASS_ACTIVE); });
    };
    return Modal;
}());
exports.default = Modal;
